var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatorbadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Property_1_bold",
    "data-name": "Property 1=bold",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.174,
    height: 14.411,
    viewBox: "0 0 11.174 14.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38821",
    "data-name": "Path 38821",
    d: "M15.143,4v.424L12.415,3.248a4.79,4.79,0,0,0-3.5,0L6.19,4.428V4c0-1.288.948-2,2.681-2h3.59C14.195,2,15.143,2.71,15.143,4Z",
    transform: "translate(-5.079 -2)",
    fill: "#4258bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38822",
    "data-name": "Path 38822",
    d: "M14.047,7.251l-.1-.052-.98-.584L10.933,5.4a2.28,2.28,0,0,0-2.192,0L6.708,6.608l-.98.6-.13.067C4.337,8.157,4.25,8.321,4.25,9.736v3.382c0,1.414.087,1.579,1.377,2.484l3.114,1.863a2.068,2.068,0,0,0,1.1.277,2.157,2.157,0,0,0,1.1-.277l3.143-1.886c1.269-.883,1.348-1.04,1.348-2.462V9.736C15.424,8.321,15.337,8.157,14.047,7.251Zm-2.2,4.138-.44.561a.555.555,0,0,0-.115.352l.043.718c.029.441-.274.666-.67.509l-.642-.269a.616.616,0,0,0-.368,0l-.642.262c-.4.165-.7-.067-.67-.509l.043-.718a.555.555,0,0,0-.115-.352l-.447-.554a.48.48,0,0,1,.26-.823l.67-.18a.584.584,0,0,0,.288-.224l.375-.6a.452.452,0,0,1,.836,0l.375.6a.573.573,0,0,0,.288.224l.67.18A.48.48,0,0,1,11.848,11.389Z",
    transform: "translate(-4.25 -3.331)",
    fill: "#4258bf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorbadge);
export default __webpack_public_path__ + "static/media/Creatorbadge.103a94c1a5e89400ac27a6e613acac42.svg";
export { ForwardRef as ReactComponent };